module.exports = __webpack_public_path__ + "img/logo.cc2d5867.svg";